import './StandardPage.scss';
import Component from './StandardPage.js';
export default Component;